import * as React from "react";

import DocExtra from "./Extra";
import DocInlineText from "./InlineText";

interface DocAudioProps extends AudioBlockNode, EveryNodeArgs {}

export default function DocAudio(props: DocAudioProps) {
  const {
    currentVersion,
    editState,
    source,
    title,
    uid,
    uri,
  } = props;

  const renderedTitle = (
    <figcaption>
      <DocInlineText
        content={title}
        uid={uid}
        contentKey="title"
        editState={editState}
      />
    </figcaption>
  );

  switch (source) {
    case "local":
      if (!("aws_folder_url" in currentVersion)) { return; }

      return (
        <div className="doc-audio doc-audio-local">
          <audio preload="none" controls>
            <source src={`${currentVersion.aws_folder_url}/original/audios/${uri}`} />
          </audio>
          {renderedTitle}
        </div>
      );
    case "soundcloud":
      return (
        <div className="doc-audio doc-audio-soundcloud">
          <iframe width="100%" height="450" scrolling="no" frameBorder="no" src={`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${uri}&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true`} />
          {renderedTitle}
        </div>
      );
    default:
      return (
        <DocExtra
          subtype="error"
          content={`Unknown audio source type: ${source}`}
          editState={editState}
        />
      );
  }
}
